import { MAX_CHARACTER_EMAIL_VALIDATION, MAX_CHARACTER_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";

export const userSettingSchema = validator.object().shape({
  userFullName: validator.string().trim().emptyToNull().label("氏名").max(MAX_CHARACTER_INPUT_VALIDATION).required(),
  userEmail: validator.string().trim().email().max(MAX_CHARACTER_EMAIL_VALIDATION).label("メールアドレス").required(),
  emailDelivery: validator.array().label("").notRequired(),
  userDepartment: validator.string().trim().emptyToNull().label("部署").max(MAX_CHARACTER_INPUT_VALIDATION).notRequired(),
  userPosition: validator.string().trim().emptyToNull().label("役職").max(MAX_CHARACTER_INPUT_VALIDATION).notRequired(),
});
